import {Service} from './../service.model';
import {FcEvent} from '../fcEvent.model';
import {Serializable} from '../deserialize.service';

export class CalendarEvent extends FcEvent implements Serializable<CalendarEvent> {
    title: string;
    start: any;
    end: any;
    resourceId: number;
    resourceIds: number[];
    backgroundColor: string;
    textColor: string;
    className: string;
    data: any;
    id: string;
    allDay: boolean;
    rendering: string;
    editable: boolean;

    deserialize(input: any, subcontractor?: any[], servicesForColor?: Service[]) {
        if (subcontractor) {
            super.deserialize(input, subcontractor, servicesForColor);
        } else {
            this.title = input.title;
            this.resourceId = input.resourceId;
            this.resourceIds = input.resourceIds;
            this.start = input.start;
            this.end = input.end;
            this.backgroundColor = input.backgroundColor;
            this.textColor = input.textColor;
            this.className = input.className;
            this.data = input.data;
            this.id = input.id;
            this.allDay = input.allDay;
            this.rendering = input.rendering;
            this.editable = input.editable;
        }
        return this;
    }
}
